import { Receipt } from '@anwb/poncho/components/receipt';
import { Theme } from '@anwb/poncho/design-tokens/theme';
import styled, { createGlobalStyle } from 'styled-components';

type DefaultThemeProps = {
	theme: Theme;
};

const receiptStyling = ({ theme }: DefaultThemeProps) => `
.subproduct > span:first-of-type {
		overflow: hidden;
		text-overflow: clip;
		display: -webkit-box;
		line-clamp: 2;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	& img {
		background-color: ${theme.colors.extralight.bgCards};
	}`;

export const ReceiptContainer = styled.div`
	${receiptStyling}
`;

interface GlobalReceiptStyleProps {
	strikeThroughMembershipCost: boolean;
}

export const ReceiptFooter = styled(Receipt.Footer)`
	width: 100%;
	display: flex;
	flex-flow: column nowrap;
	align-items: center;
`;

export const GlobalReceiptStyle = createGlobalStyle<GlobalReceiptStyleProps>`
  ${(props) =>
		props.strikeThroughMembershipCost &&
		`
	[data-test='private-lease-receipt-footer-sub'] {
		text-decoration: line-through;
	}`};
`;
